import { render } from "./producer-create.vue?vue&type=template&id=f93f0506"
import script from "./producer-create.vue?vue&type=script&lang=js"
export * from "./producer-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__